import { useContext, useEffect, useState } from "react";
import RMFolders from "./restaurant-menu-folders/restaurant-menu-folders.component";
import {
  getCategories,
  addCategoryUtil,
  addItem,
} from "../../../utils/restaurant-edit";
import "./restaurant-menu.styles.scss";
import RMCategories from "./restaurant-menu-categories/restaurant-menu-categories.component";
import { MenuContext } from "../../../contexts/menu.context";
import RMAdd from "./restaurant-menu-add/restaurant-menu-add.component";
import RMView from "./restaurant-menu-view/restaurant-menu-view.component";
const RestaurantMenu = () => {
  const [menu, setMenu] = useState({});
  const [folders, setFolders] = useState([]);
  const [categories, setCategories] = useState([]);
  const { menuContext, setMenuContext } = useContext(MenuContext);

  useEffect(() => {
    if (menuContext) {
      setMenu(menuContext);
    }
    setCategories(getCategories(folders, menu));
  }, [folders, menu, menuContext]);
  const addItemFunction = (item) => {
    let tempMenu = addItem(item, menu, folders);
    setMenuContext({ ...tempMenu });
  };
  const moveBackFolder = (name, index) => {
    if (index === -1) {
      setFolders([]);
    } else {
      let tempFolders = folders.filter((folder, i) => {
        return i <= index;
      });
      setFolders([...tempFolders]);
    }
  };
  const addCategory = (categoryName) => {
    let tempMenu = addCategoryUtil(categoryName, menu, folders);
    setMenu({ ...tempMenu });
    setMenuContext({ ...tempMenu });
  };
  const moveIntoFolder = (name) => {
    setFolders([...folders, name]);
  };
  const [alterClass, setAlterClass] = useState("rm-mobile-button active");
  const [viewClass, setViewClass] = useState("rm-mobile-button");
  const [currentPane, setCurrentPane] = useState("alter");
  const changePane = (pane) => {
    setCurrentPane(pane);
    if (pane === "alter") {
      setAlterClass("rm-mobile-button active");
      setViewClass("rm-mobile-button");
    } else if (pane === "view") {
      setAlterClass("rm-mobile-button");
      setViewClass("rm-mobile-button active");
    }
  };
  return (
    <div className="restaurant-menu-container">
      {window.innerWidth > 1024 ? (
        <div className="restaurant-menu-desktop">
          <div className="restaurant-menu-left">
            <div className="rm-left-folders">
              <RMFolders folders={folders} moveBackFolder={moveBackFolder} />
            </div>
            <div className="rm-left-categories">
              <RMCategories
                categories={categories}
                moveIntoFolder={moveIntoFolder}
                addCategory={addCategory}
              />
            </div>
            <div className="rm-left-additem">
              <RMAdd addFunction={addItemFunction} />
            </div>
          </div>
          <div className="restaurant-menu-right">
            <div className="rm-right-menu">
              <RMView />
            </div>
          </div>
        </div>
      ) : (
        <div className="restaurant-menu-mobile">
          <div className="rm-mobile-buttons">
            <span className={alterClass} onClick={() => changePane("alter")}>
              Alter Menu
            </span>
            <span className={viewClass} onClick={() => changePane("view")}>
              {" "}
              View Menu
            </span>
          </div>
          {currentPane === "alter" ? (
            <div className="restaurant-menu-left">
              <div className="rm-left-folders">
                <RMFolders folders={folders} moveBackFolder={moveBackFolder} />
              </div>
              <div className="rm-left-categories">
                <RMCategories
                  categories={categories}
                  moveIntoFolder={moveIntoFolder}
                  addCategory={addCategory}
                />
              </div>
              <div className="rm-left-additem">
                <RMAdd addFunction={addItemFunction} />
              </div>
            </div>
          ) : (
            <div className="restaurant-menu-right">
              <div className="rm-right-menu">
                <RMView />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default RestaurantMenu;
